var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAfterpay = function SvgAfterpay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.25,
    width: 25.5,
    height: 25.5,
    rx: 12.75,
    fill: "#00D632"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.25,
    width: 25.5,
    height: 25.5,
    rx: 12.75,
    stroke: "#F5F5F5",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.426 10.925a.475.475 0 0 0 .675 0l.938-.975c.198-.187.187-.525-.023-.727a7.398 7.398 0 0 0-2.52-1.44l.297-1.425a.498.498 0 0 0-.48-.604h-1.815a.495.495 0 0 0-.48.397l-.263 1.268c-2.415.124-4.463 1.35-4.463 3.862 0 2.175 1.692 3.109 3.48 3.75 1.692.645 2.588.885 2.588 1.793 0 .933-.893 1.481-2.212 1.481-1.2 0-2.46-.401-3.436-1.38a.49.49 0 0 0-.69 0L8.01 17.937a.51.51 0 0 0 0 .72c.787.777 1.785 1.34 2.922 1.65l-.277 1.34c-.064.31.165.6.476.603l1.819.015a.495.495 0 0 0 .487-.398l.263-1.27c2.905-.196 4.675-1.797 4.675-4.133 0-2.153-1.762-3.06-3.9-3.799-1.223-.454-2.28-.765-2.28-1.699 0-.907.986-1.267 1.976-1.267 1.26 0 2.471.521 3.263 1.233l-.008-.007Z",
    fill: "#fff"
  })));
};
export default SvgAfterpay;